import { ButtonHTMLAttributes, forwardRef, memo } from "react";
import classNames from "classnames";

import { ReactComponent as CloseIcon } from "./icons/close.svg";

import styles from "./styles.module.scss";

export type CloseButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children">

export const CloseButton = memo(forwardRef<HTMLButtonElement, CloseButtonProps>((
  {
    className,
    ...props
  },
  ref,
) => {
  return (
    <button
      type="button"
      {...props}
      className={classNames(className, styles.root)}
      ref={ref}
    >
      <CloseIcon />
    </button>
  );
}));